import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { SessionSiteSelectors } from '../../selectors/SessionInfoSelectors';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { SiteUserSpace, SiteUserSpaceDispatchProps, SiteUserSpaceStateProps } from './SiteUserSpace';

const mapStateToProps: MapStateToProps<SiteUserSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentCounts: selectContentCounts<'siteuser'>(state, 'siteuser'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  isDataAlertsEnabled: SessionSiteSelectors.isDataAlertsEnabled(state),
});

const mapDispatchToProps: MapDispatchToProps<SiteUserSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedSiteUserSpace = connect(mapStateToProps, mapDispatchToProps)(SiteUserSpace);
